import Service, { service } from '@ember/service';
import { waitForPromise } from '@ember/test-waiters';

export default class FeedbackService extends Service {
  @service site;
  @service logger;
  deliverFeedback(name, email, feedback) {
    let siteconfig = this.site;
    let feedbackData = {
      ToolId: 5,
      Name: encodeURIComponent(name),
      Email: encodeURIComponent(email),
      Feedback: encodeURIComponent(feedback),
    };
    return waitForPromise(
      fetch(`${siteconfig.ApiUrl}/feedback/${siteconfig.AdiLocale}`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(feedbackData),
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          this.logger.error(`Give feedback failed: ${error}`);
          return { status: -1 };
        }),
    );
  }
}
